import { Button } from "@mui/material";

const ButtonGroup = ({ list, activeVal, onChange, size = "medium" }) => {
  return (
    <div className="d-flex bg-primarySM br-8">
      {list &&
        list.map((item, ind) => (
          <Button
            key={ind}
            variant="text"
            size={size}
            onClick={() => onChange(item.id)}
            className={`fs-16 ${
              item.id === activeVal && "bg-primary white-color"
            }`}
            sx={{
              bgcolor: "transparent",
              minWidth: "40px",
              paddingLeft: "0px",
              paddingRight: "0px",
              height: "100%",
            }}
          >
            {item.label}
          </Button>
        ))}
    </div>
  );
};

export default ButtonGroup;
